export default __webpack_public_path__ + "static/media/control-foto2.7921ebe1.jpg";